import { render, staticRenderFns } from "./StockRelocation.vue?vue&type=template&id=efdca698&"
import script from "./StockRelocation.vue?vue&type=script&lang=ts&"
export * from "./StockRelocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports